import React, { useState } from "react";
import { Logo } from "../components/shared/Logo";
import { useAuth } from "../contexts/AuthContext";

export const LoginPage: React.FC = () => {
	const { login } = useAuth();
	const [email, setEmail] = useState("admin@teknuluguy.com");
	const [pass, setPass] = useState("admin123");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const handleLogin = async () => {
		if (!email || !pass) {
			setError("Email and password required");
			return;
		}
		setLoading(true);
		setError("");
		try {
			await login(email, pass);
		} catch (e: any) {
			setError(e.response?.data?.message || "Login failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				background:
					"radial-gradient(ellipse at 30% 40%,rgba(34,197,94,.07),transparent 60%),var(--bg)",
			}}>
			<div
				style={{
					background: "var(--surf)",
					border: "1px solid var(--border2)",
					borderRadius: 20,
					padding: 40,
					width: 400,
					boxShadow: "0 20px 60px rgba(0,0,0,.6)",
				}}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: 12,
						marginBottom: 8,
					}}>
					<Logo />
					{/* <Logo size={48} />
          <span style={{ fontFamily:'Syne,sans-serif', fontSize:20, fontWeight:800, background:'linear-gradient(135deg,#06a384,#4ade80)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            Teknuluguy
          </span> */}
					{/* <img src={logoImage} alt="Teknuluguy Logo" /> */}
				</div>
				<p
					style={{
						textAlign: "center",
						color: "#FFF",
						fontSize: 12,
						marginBottom: 28,
					}}>
					Admin Panel — Secure Access
				</p>

				<div className="form-group">
					<label className="form-label">Email Address</label>
					<input
						className="form-input"
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						onKeyDown={(e) => e.key === "Enter" && handleLogin()}
						placeholder="admin@teknuluguy.com"
					/>
				</div>
				<div className="form-group">
					<label className="form-label">Password</label>
					<input
						className="form-input"
						type="password"
						value={pass}
						onChange={(e) => setPass(e.target.value)}
						onKeyDown={(e) => e.key === "Enter" && handleLogin()}
						placeholder="••••••••"
					/>
				</div>

				{error && (
					<div
						style={{
							color: "var(--red)",
							fontSize: 12,
							textAlign: "center",
							background: "rgba(239,68,68,.1)",
							borderRadius: "var(--rs)",
							padding: 8,
							marginBottom: 8,
						}}>
						{error}
					</div>
				)}

				<button
					className="btn-primary"
					onClick={handleLogin}
					disabled={loading}
					style={{
						width: "100%",
						padding: 13,
						fontSize: 14,
						fontFamily: "Syne,sans-serif",
						fontWeight: 800,
						borderRadius: "var(--r)",
						marginTop: 6,
					}}>
					{loading ? "Logging in…" : "Access Admin Panel →"}
				</button>

				{/* <div
					style={{
						fontSize: 11,
						color: "var(--muted)",
						textAlign: "center",
						marginTop: 16,
						padding: 10,
						background: "var(--card)",
						borderRadius: "var(--rs)",
						lineHeight: 1.7,
					}}>
					<strong>Demo Credentials</strong>
					<br />
					admin@teknuluguy.com / admin123
					<br />
					sara@teknuluguy.com / manager123
					<br />
					omar@teknuluguy.com / cashier123
				</div> */}
			</div>
		</div>
	);
};
